import { appConfig } from './AppConfig';
import { localhostTreatments } from './LocalhostTreatments';

const isLocalhostMode: boolean = appConfig.split.localhostMode;
const authorizationKey: string = isLocalhostMode ? 'localhost' : (appConfig.split.clientKey ?? '');
const key: string = isLocalhostMode ? 'localhost' : 'anonymous';

export const splitConfig = {
  core: {
    authorizationKey,
    key,
  },
  features: localhostTreatments,
};
